// import { useEffect, useState } from 'react';
import './style.scss';
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import Heading from '../../Components/Heading/Heading';
import socials from '../../content/Socials'
import Typewriter from "typewriter-effect";




const Home = (props) => {
    return (
      <div className="container">
        <motion.di 
          className="pfp"
        >
          <img src={props.img} alt="" />
        </motion.di>
  
        <Heading firstWord="Qui" secondWord="Suis-je?" />
        <div className="Home-typewriter">
          <h3>Je suis</h3>
          <Typewriter
            options={{
              strings: [
                
"Un développeur en formation.",
"Un passionné de site web.",
"Un passionné d'IA.",
"Un élève.",
              ],
              autoStart: true,
              loop: true,
            }}
            className="typewriter"
          />
        </div>
    
        <div className="button-effect">

          <div className="Home-text">
            <p className="Home-desc">{props.description}</p>
          </div>
          <br />
          <br />
          Retrouvez-Moi aussi ici:
          <div className="Home-socials">
            {socials.map((social, index) => (
              <a key={index} href={social.url}>
                <img src={`/socials/${social.icon}`} alt="" />
              </a>
            ))}
          </div>
        </div>
      </div>
    );
  };
  
Home.propTypes = {
    img: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  };
  
export default Home;
